/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".iti-banner[_ngcontent-%COMP%]{padding:12px 70px;display:flex;align-items:center;align-content:center;box-shadow:0 4px 4px 0 rgba(214,214,214,.24)}@media (max-width:767.98px){.iti-banner[_ngcontent-%COMP%]{flex-direction:column;padding:12px 20px}}.iti-banner[_ngcontent-%COMP%]   .iti-banner-logo[_ngcontent-%COMP%]{flex:1}.iti-banner[_ngcontent-%COMP%]   .iti-banner-logo[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:60px}.iti-banner[_ngcontent-%COMP%]   .iti-banner-info[_ngcontent-%COMP%]{color:#a8a8a8}"];
export { styles as styles };
